export async function GravarSessao(empresaId) {
    const empresa = sessionStorage.setItem("empresa", empresaId);
  
    return { empresa };
  }